
import './App.css';
import Todo from "./Components/Todo-React/Todo"

function App() {
  return (
      <>
      <Todo/>
      </>
  );
}

export default App;
